export default function Footer(): JSX.Element {
    return (
        <div className="footer">
            Todos los derechos reservados © 2021
            <div className="release">Versión 2024.10.21</div>
        </div>
    );
}
